export function classNames(cons, ...always) {
    const out = always.slice();
    for (const k of Object.keys(cons)) {
        if (cons[k]) {
            out.push(k);
        }
    }
    return out.join(' ');
}
//# sourceMappingURL=classNames.js.map